import {fetchWithState, getFetchedJSON} from '~/misc/fetch';
import { getCode } from '~/misc/loadStatus';
export const cteateBids =  (getState, price, shipmentId) => {
  return fetchWithState(getState, {
    url: '/tl/bids/create',
    method: 'POST',
    body: {
      price_dollar: price,
      shipment_id: shipmentId
    }
  }, false).then(getFetchedJSON);
}

export const createBidDynamic =  (getState, shipmentId, nextNode = '',price = '',) => {
  return fetchWithState(getState, {
    url: '/tl/bids/dynamic/create',
    method: 'POST',
    body: {
      price_dollar: price,
      shipment_id: shipmentId,
      message:"",
      next_node: nextNode
    }
  }, false).then(getFetchedJSON).then(getCode)
}

export const confirmBid =  (getState, userId) => {
  return fetchWithState(getState, {
    url: `/tl/bids/updateAllowUploadStatus?userId=${userId}`,
    method: 'GET',
  }, false).then(getFetchedJSON)
}



export const getBidLoads =  (getState) => {
  return fetchWithState(getState, {
    url: '/tl/bids/myjobs/list?page=0&pageSize=1000',
    method: 'GET',
  }, false).then(getFetchedJSON)
}


export const acceptBid = (getState, nextNode) => {
  return fetchWithState(getState, {
    url: '/tl/bids/action',
    method: 'POST',
    body: {
      action_info: nextNode
    }
  }, false).then(getFetchedJSON)
}


// WEBPACK FOOTER //
// ./src/api/bid.js